import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { globalSlice } from './slices/globalSlice';
import { userSlice } from './slices/userSlice';

import type { TypedUseSelectorHook } from 'react-redux';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    global: globalSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['user/setTokens'],
        ignoredPaths: ['user.tokenExpiry'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
